<template>
	<div class="x-empty">
		<template v-if="!props.hideIcon">
			<img v-if="type === 'search'" src="@/assets/img/commonLayout/empty2.png" alt="" />
			<img v-else src="@/assets/img/commonLayout/empty.png" alt="" />
			<span>{{ props.title || '暂无数据~' }}</span>
		</template>
		<span class="only-text" v-else>{{ props.title || '暂无数据~' }}</span>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	title?: string
	type?: string
	hideIcon?: boolean
}>()
</script>

<style scoped lang="scss">
.x-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-weight: 400;
	font-size: $commonFontSize;
	color: #6d6d6d;
	line-height: 19px;
	text-align: left;
	font-style: normal;
	text-transform: none;
	padding-top: 20px;
	> img {
		width: 300px;
	}
	> span {
		margin-top: 10px;
	}
	> .only-text {
		margin-bottom: 20px;
		font-size: $commonFontSize;
	}
}
</style>
